import React, { push, Component } from "react";
import {
  Grommet,
  Box,
  Header,
  Button,
  Layer,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  Card,
  CardHeader,
  CardBody,
  List,
  Grid,
  TextInput,
  Select,
  RadioButtonGroup,
  Form,
  CheckBox,
  DateInput,
  FormField,
  CheckBoxGroup,
  Tabs,
  Tab,
  Image,
  CardFooter,
  IFrame,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Console,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  CaretDownFill,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Filter,
  Video,
  DocumentPdf,
  Inspect,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import GetHelpR1 from "./GetHelpR1";

class GetHelpVIDEOSDOCS extends Component {
  //const { push } = React.useContext(RouterContext);
  constructor(props) {
    super(props);

    this.state = {
      bnullIssuedisplay: false,
    };
    this._setHide = this._setHide.bind(this);
    this._dispVIssueSol1 = this._dispVIssueSol1.bind(this);
  }

  componentDidMount() {}

  _dispVIssueSol1 = () => {
    this.setState({ bnullIssuedisplay: true });
  };

  _setHide = () => {
    this.setState({ bnullIssuedisplay: false });
  };

  render() {
    var b_displayNullFileIssue = this.state.bnullIssuedisplay;

    return (
      <Box>
        <Layer
          full={true}
          position="center"
          height="medium"
          onClickOutside={this.props.hide}
          onEsc={this.props.hide}
        >
          <Box fill="vertical" align="stretch" justify="start">
            <Main
              overflow="auto"
              background={{ image: "url('')" }}
              flex
              align="stretch"
              justify="start"
            >
              <Box
                align="stretch"
                justify="center"
                flex="grow"
                background={{ color: "background-back" }}
                direction="row"
              >
                <Box
                  align="stretch"
                  justify="start"
                  flex="shrink"
                  pad={{ horizontal: "large", vertical: "medium" }}
                  basis="xlarge"
                  direction="column"
                  gap="medium"
                >
                  <Box align="center" justify="end" direction="row">
                    <Button
                      icon={<Close />}
                      onClick={this.props.hide}
                      secondary
                    />
                  </Box>
                  <Header
                    align="start"
                    direction="column"
                    flex={false}
                    justify="start"
                    gap="xxsmall"
                  >
                    {/*                   <Button
                    label="Back"
                    icon={<FormPrevious />}
                    onClick={() => push("/gethelp")}
                  /> */}
                    <Heading margin="none">
                      Get Help on Videos and Documents
                    </Heading>
                  </Header>
                  <Box
                    align="stretch"
                    justify="center"
                    pad="medium"
                    gap="large"
                    direction="column"
                  >
                    <Grid
                      columns={["medium", "medium", "medium"]}
                      rows="medium"
                      gap="medium"
                    >
                      <Card hoverIndicator onClick={this._dispVIssueSol1}>
                        <CardHeader
                          align="center"
                          direction="row"
                          flex={false}
                          justify="between"
                          gap="medium"
                          pad="small"
                        >
                          <Heading size="small">
                            .NULL file extension when downloading document
                          </Heading>
                        </CardHeader>
                        <CardBody pad="small">
                          <Image
                            src="/img/GetHelp/GHR1-documentnull.png
"
                            fit="contain"
                          />
                        </CardBody>
                        <CardFooter
                          align="center"
                          direction="row"
                          flex={false}
                          justify="between"
                          gap="medium"
                          pad="small"
                        >
                          <Text size="xsmall">#GH-R1</Text>
                        </CardFooter>
                      </Card>
                    </Grid>
                  </Box>
                </Box>
              </Box>
            </Main>
          </Box>
        </Layer>
        {b_displayNullFileIssue && (
          <GetHelpR1 disp={b_displayNullFileIssue} hide={this._setHide} />
        )}
      </Box>
    );
  }
}
export default GetHelpVIDEOSDOCS;
